module.exports = __webpack_public_path__ + "static/media/GPG141B_H07_HO.1d3cb6f9.jpg";